import { Icon as SemanticUIIcon } from 'semantic-ui-react';
import styled from 'styled-components';

const Icon = styled(SemanticUIIcon)`
  font-size: 2.6rem !important;
  margin: 0 !important;
`;

export default Icon;
